import { Injectable } from '@angular/core';
import { UserService } from '../../services/user.service';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  slug?: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  slug?: string[];
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
  temporaryChildren?: ChildrenItems[];
}

const MENUITEMS: Menu[] = [
  {
    state: 'planes',
    name: 'Planes',
    type: 'link',
    icon: 'sticky_note_2',
    slug: ['dashboard.plans.list']
  },
  {
    state: 'settings',
    name: 'Configuración',
    type: 'link',
    icon: 'build',
    slug: ['dashboard.industries.list', 'dashboard.team-size.list']
  },
  {
    state: 'customers',
    name: 'Clientes',
    type: 'link',
    icon: 'groups',
    slug: ['dashboard.clients.list']
  },
  {
    state: 'users',
    name: 'Usuarios',
    type: 'link',
    icon: 'groups',
    slug: ['dashboard.users.list']
  },
  {
    state: 'analisis',
    name: 'Análisis',
    type: 'link',
    icon: 'trending_up',
    slug: ['dashboard.analysis.clients', 'dashboard.analysis.user-clients', 'dashboard.analysis.use-time', 'dashboard.analysis.impacts']
  },
  /* {
     state: 'plugin',
     name: 'Plugins',
     type: 'link',
     icon: 'extension',
     slug: ['dashboard.plugins.list']
   },*/
  {
    state: 'users',
    name: 'Usuarios',
    icon: 'people',
    slug: ['dashboard.user.list', 'dashboard.role.list'],
    type: 'sub',
    temporaryChildren: [
      // { state: 'login', name: 'LOGIN' },
      // { state: 'register', name: 'REGISTER' },
      // { state: 'forgot-password', name: 'FORGOT' },
      // { state: 'lockscreen', name: 'LOCKSCREEN' }
      { state: 'list', name: 'Lista de usuarios', slug: 'dashboard.user.list' },
      { state: 'roles', name: 'Roles', slug: 'dashboard.role.list' }
    ]
  }
];

@Injectable()
export class MenuItems {
  constructor(
    private userService: UserService
  ) {

  }
  getAll(): Menu[] {
    let menuItems = [];
    if (!this.userService.user.value) {
      return menuItems;
    }
    let permissions = [];
    const isAgent = this.userService.user.value.roles.filter(rl => rl.id <= 3).length > 0;
    if (isAgent) {
      permissions = this.userService.user.value.permissions.map(p => p.slug).concat(['kanban', 'calendar']);
    } else {
      permissions = this.userService.user.value.permissions.map(p => p.slug);
    }
    let slugMenu = [];
    menuItems = MENUITEMS.filter(m => {
      slugMenu = m.slug.filter(s => permissions.indexOf(s) !== -1 || s === 'all');
      if (m.temporaryChildren) {
        m.children = m.temporaryChildren.filter(c => permissions.indexOf(c.slug) !== -1 || c.slug === 'all');
      }
      if (slugMenu.length > 0) {
        return m;
      }
    });
    return menuItems;
  }

  add(menu: Menu) {
    MENUITEMS.push(menu);
  }
}
